import { PRESUPUESTADOR_SET_LINES_FINANCE } from './constants'

export function setLinesFinance(lines) {
    return dispatch => {
        dispatch({
            type: PRESUPUESTADOR_SET_LINES_FINANCE,
            data: { lineasFinancieras: lines }
        })
    }
}

export function reducer(state, action) {
    if (action.type === PRESUPUESTADOR_SET_LINES_FINANCE) {
        return {
            ...state,
            lineasFinancieras: action.data.lineasFinancieras
        }
    } else {
        return state
    }
}
